import config from "@lib/config";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { getSession } from "next-auth/react";

export default async function pusher() {
  if (typeof window === "undefined") return;

  window.Pusher = Pusher;

  // Get the session to access the bearer token
  const session = await getSession();
  const apiUrl = config.apiBaseUrl;

  window.Echo = new Echo({
    broadcaster: "pusher",
    key: config.pusherAppKey,
    cluster: "ap4",
    forceTLS: true,
    auth: {
      headers: {
        Authorization: session?.accessToken
          ? `Bearer ${session.accessToken}`
          : "",
      },
    },
    authEndpoint: `${apiUrl}/broadcasting/auth`,
  });
}
